import styled from 'styled-components';
import { colorMediumGray, colorRed } from '../../config/theme';

export const StyledNativeInput = styled.input<{invalid?: boolean}>`
    display: block;
    border: solid 2px ${colorMediumGray};
    color: ${colorMediumGray};
    padding: 0.8rem;
    width: 100%;
    font-size: 1rem;

    ${(props) => props.invalid ? `
        ::placeholder {
            color: inherit;
        }
        color: ${colorRed};
        border-color: ${colorRed};
    ` : ''}
`;
